// initial state
import axios from "axios";

let baseURL = 'https://admin.hoptone.com/api/';
const debug = process.env.NODE_ENV !== 'production';

if (debug) {
    baseURL = 'http://hoptone.test/api/'
} else {
    baseURL = 'https://admin.hoptone.com/api/'
}

const state = {
    token: localStorage.getItem('user-token') || '',
    status: '',
    admin: sessionStorage.getItem('admin') || 0,
    oldUserBilling: sessionStorage.getItem('oldUserBilling') || 0,
};

// getters
const getters = {
    isAuthenticated: state => state.token !== '',
    authStatus: state => state.status,
    isAdmin: state => state.admin,
    isOldUserBilling: state => state.oldUserBilling,
};

// actions
const actions = {
    AUTH_REQUEST: ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit('AUTH_REQUEST');
            axios({
                url: baseURL + 'login/', data: user, method: 'POST', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    const token = resp.data.access_token;
                    localStorage.setItem('user-token', token); // store the token in localstorage
                    localStorage.setItem('permissions', 'admin'); // store the token in localstorage

                    commit('AUTH_SUCCESS', token);

                    // you have your token, now log in your user :)
                    // dispatch('customer/loadUser')
                    resolve(resp)
                })
                .catch(err => {
                    commit('AUTH_ERROR', err);
                    localStorage.removeItem('user-token'); // if the request fails, remove any possible user token if possible
                    reject(err)
                })
        })
    },
    AUTH_PASS_RESET_REQUEST: ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit('AUTH_PASS_RESET');
            axios({
                url: baseURL + 'forgot', data: user, method: 'POST', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    commit('AUTH_ERROR', err);
                    reject(err)
                })
        })
    },
    AUTH_PASS_RESET: ({commit, dispatch}, {password, token}) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit('AUTH_PASS_RESET');
            axios({
                url: baseURL + 'reset', data: {
                    password: password,
                    token: token
                }, method: 'POST', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    commit('AUTH_ERROR', err);
                    reject(err)
                })
        })
    },
    AUTH_CHECK_TOKEN: ({commit, dispatch}, token) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit('AUTH_PASS_RESET');
            axios({
                url: baseURL + 'token/' + token.token, method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    commit('AUTH_ERROR', err);
                    reject(err)
                })
        })
    },
    AUTH_LOGOUT: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('AUTH_LOGOUT');
            localStorage.removeItem('user-token'); // clear your user's token from localstorage
            sessionStorage.removeItem('permissions'); // clear your user's token from localstorage
            sessionStorage.removeItem('admin'); // clear your user's token from localstorage
            localStorage.removeItem('teacher')
            resolve()
        })
    },
    AUTH_ADMIN_LOGIN: ({commit, dispatch}, token) => {
        return new Promise((resolve, reject) => {
            localStorage.setItem('user-token', token); // store the token in localstorage
            sessionStorage.setItem('admin', '1'); // store the token in localstorage
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            commit('AUTH_SUCCESS', token);
            commit('AUTH_ADMIN');
            resolve();
        })
    },
    AUTH_TEACHER_LOGIN: ({commit, dispatch}, token) => {
        return new Promise((resolve, reject) => {
            return axios({
                url: baseURL + 'teacher/tokenlogin', data: {token: token}, method: 'POST', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    const token = resp.data.access_token;
                    localStorage.setItem('user-token', token); // store the token in localstorage
                    localStorage.setItem('permissions', 'teacher'); // store the token in localstorage
                    localStorage.setItem('teacher', resp.data.classroom_id); // store the classroom id in localstorage

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    commit('AUTH_SUCCESS', token);
                    resolve(resp)
                })
                .catch(err => {
                    commit('AUTH_ERROR', err);
                    localStorage.removeItem('user-token'); // if the request fails, remove any possible user token if possible
                    reject(err)
                })
        })
    },
    AUTH_OLD_USER_BILLING_LOGIN: ({commit, dispatch}, token) => {
        return new Promise((resolve, reject) => {
            localStorage.setItem('user-token', token); // store the token in localstorage
            sessionStorage.setItem('oldUserBilling', '1'); // store the token in localstorage
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            console.log('Set bearer and token');
            commit('AUTH_SUCCESS', token);
            resolve();
        })
    }
};

// mutations
const mutations = {
    AUTH_REQUEST: (state) => {
        state.status = 'loading'
    },
    AUTH_PASS_RESET: (state) => {
        state.status = 'loading'
    },
    AUTH_SUCCESS: (state, token) => {
        state.status = 'success';
        state.token = token;
    },
    AUTH_ADMIN: (state) => {
        state.admin = true;
    },
    AUTH_ERROR: (state) => {
        state.status = 'error'
    },
    AUTH_LOGOUT: (state) => {
        state.status = '';
        state.token = '';
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
